<template>
  <el-tree
    ref="refTree"
    :data="data"
    :show-checkbox="showCheckbox"
    node-key="id"
    default-expand-all
    :expand-on-click-node="false"
    icon-class="icon-CaretRight"
    v-bind="$attrs"
    v-on="$listeners"
    @node-contextmenu="contextmenu"
    @node-click="nodeClick"
    @node-drop="nodeDrop"
    :filter-node-method="filterNode"
    :highlight-current="true"
  >
    <div class="custom-tree-node" slot-scope="{ node, data }">
      {{ node.label }}
      <template v-if="reg">
        <div class="context-menu" v-if="data.menuBtn">
          <el-button type="text" size="mini" @click="() => append(node)"
            ><i class="icon-Copy" />하위메뉴 추가</el-button
          >
        </div>
      </template>
      <template v-if="knwlgReg">
        <!-- 22.03.22 지식자료실 버튼 추가-->
        <div class="context-menu" v-if="data.menuBtn">
          <el-button type="text" size="mini" @click="knwlgRegFunc(node)"
            ><i class="icon-Copy" />등록</el-button
          >
          <el-button v-if="modFunc" type="text" size="mini" @click="addFolder('insert')"
            ><i class="icon-Copy" />폴더추가</el-button
          >
          <el-button
            v-if="modFunc"
            type="text"
            size="mini"
            @click="flDelFunc(node)"
            ><i class="icon-Copy" />폴더삭제</el-button
          >
          <el-button v-if="modFunc" type="text" size="mini" @click="addFolder('update', node)"
            ><i class="icon-Copy" />폴더변경</el-button
          >
        </div>
        <!-- 22.03.22 지식자료실 버튼 추가-->
      </template>
    </div>
  </el-tree>
</template>

<script>
import { mapGetters } from "vuex";
import { isEmpty } from "@/assets/js/common.js";

export default {
  props: {
    treeList: {
      type: Array,
      default: () => [],
    },
    reg: {
      type: Boolean,
      default: false,
    },
    knwlgReg: {
      // 22.03.16 지식자료실 등록버튼 추가
      type: Boolean,
      default: false,
    },
    showCheckbox: {
      type: Boolean,
      default: true,
    },
    modFunc: {
      // 22.03.22 지식자료실 등록버튼 추가
      type: Boolean,
      default: false,
    },
    filterText: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // data: this.treeList,
    };
  },
  computed: {
    data() {
      return JSON.parse(JSON.stringify(this.treeList));
    },
  },
  methods: {
    contextmenu(e, object, value) {
      value.data.menuBtn = !value.data.menuBtn;
      if (this.oldClickNode && this.oldClickNode.data.id !== value.data.id) {
        this.oldClickNode.data.menuBtn = false;
      }
      this.oldClickNode = value;
    },
    append(node) {
      this.$emit("nodeAppend", node);
    },
    workFlow() {
      this.$emit("isWorkFlow");
    },
    nodeClick(node) {
      //console.log(arguments);
      //console.log(node)
      if(!isEmpty(this.oldClickNode)){
        this.oldClickNode.data.menuBtn = false;
      }
      this.$emit("nodeClick", node);
    },
    knwlgRegFunc(node) {
      // 22.03.16 지식자료실 등록버튼 추가
      this.$emit("knwlgReg", node);
    },
    addFolder(mode, node) {
      // 22.03.22 폴더추가
      this.$emit("addFolder", mode, node);
    },
    flDelFunc(node) {
      this.oldClickNode.data.menuBtn = false;
      // 22.03.22 폴더추가
      /* if (node.childNodes.length > 0) {
        this.$emit("openDelModal", true, node);
      } else { */
        this.$emit("openDelModal", false, node);
      /* } */
    },
    nodeDrop(draggingNode, dropNode){
      // console.log("==dragging ", draggingNode, "==drop ", dropNode)

      // var temp = draggingNode.data.upMenuId
      // console.log(this.data.filter( x => x.id === temp));

      this.$emit("changeMenuList", this.data)
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1
    },
  },

  watch: {
    filterText(val) {
      this.$refs.refTree.filter(val);
    }
  }
};
</script>

<style lang="scss">
.custom-tree-node {
  display: block;
  width: 100%;
}
// 2022.03.16 스타일 공통으로 이동
.context-menu {
  position: absolute;
  right: 0;
  margin-top: -20px;
  background: $--color-white;
  padding: 10px 15px 10px 10px;
  border: 1px solid $--color-light-gray {
    radius: 5px;
  }
  z-index: 10;
  .el-button {
    display: flex;
    align-items: center;
    height: 30px;
    width: 100%;
    text-align: left;
    color: $--color-black;
    font: {
      size: $--font-size-base;
      weight: $--font-weight-default;
    }
    [class^="icon-"],
    [class*="icon-"] {
      margin-right: 3px;
    }
    & + .el-button {
      margin-left: 0;
    }
  }
}
</style>
